import Repository from "../../repository";

export default {
    GetSales: (payload) => Repository.post(`/api/GasReports/GetSales`, payload),
    GetDeliverys: (payload) => Repository.post(`/api/GasReports/GetDeliverys`, payload),
    GetDebits: (payload) => Repository.post(`/api/GasReports/GetDebits`, payload),
    GetDebitTanks: (payload) => Repository.post(`/api/GasReports/GetDebitTanks`, payload),
}
